import { render, staticRenderFns } from "./retrievalDetail.vue?vue&type=template&id=17dd2bb7&scoped=true&"
import script from "./retrievalDetail.vue?vue&type=script&lang=js&"
export * from "./retrievalDetail.vue?vue&type=script&lang=js&"
import style0 from "./retrievalDetail.vue?vue&type=style&index=0&id=17dd2bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd2bb7",
  null
  
)

export default component.exports